import {
  DATASTRATEGY,
  IEntity,
  STORAGESTRATEGY,
} from '@proximus/entity-manager';
import { SessionStorageStrategy } from '@proximus/entity-manager/lib/storage/strategies/session-storage.strategy';

export const PublicWifiPxsplusProductsEntity: IEntity<any> = {
  url: '/rest/smart-wifi/products',
  requestHeaders: [
    'language',
    'proximusContentType',
    'userId',
    'etag',
    'encryptionKey',
  ],
  rel: 'sw:products',
  version: 'v1',
  parentRel: 'index',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.PROXY_STORAGE,
  storageStrategy: SessionStorageStrategy.ID,
};

export const PublicWifiPxsplusGetConfigureUrlEntity: IEntity<any> = {
  url: '/rest/smart-wifi/assignedProduct/{serviceId}/configurationKey{?deviceOperatingSystem,filter,deviceOsVersion,abroad}',
  requestHeaders: [
    'language',
    'proximusContentType',
    'userId',
    'etag',
    'encryptionKey',
    'customHeaders',
  ],
  rel: 'sw:configureUrl',
  version: 'v1',
  parentRel: 'index',
  timeout: 30000,
  dataStrategy: DATASTRATEGY.NONE,
  storageStrategy: STORAGESTRATEGY.NONE,
  customHeaders: {
    Accept: 'application/json',
  },
};
